import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, LogOut, BookOpen, MessageSquare, UsersRound, History, UserCircle, Settings } from 'lucide-react';

const Dashboard = () => {
    const navigate = useNavigate();
    const user = JSON.parse(sessionStorage.getItem('user'));
    const isAdmin = user?.roles === 'ADMIN';

    const handleLogout = () => {
        sessionStorage.clear();
        navigate('/login');
    };

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <h1>Acu Slim Medica</h1>
                <div style={styles.userInfo}>
                    <span>Dobrodošli, <strong>{user?.username}</strong></span>
                    <button onClick={handleLogout} style={styles.logoutBtn}>
                        <LogOut size={18} />
                    </button>
                </div>
            </header>

            <div style={styles.grid}>
                <div style={styles.card} onClick={() => navigate('/group-scheduling')}>
                    <UsersRound size={48} color="#14b8a6" />
                    <h3>Zakazivanje termina</h3>
                    <p>Prvi pregledi, kontrole... — dodajte više pacijenata na istu satnicu</p>
                </div>

                <div style={styles.card} onClick={() => navigate('/patients')}>
                    <Users size={48} color="#f59e0b" />
                    <h3>Lista pacijenata</h3>
                    <p>Evidencija i istorija svih pacijenata</p>
                </div>

                <div style={styles.card} onClick={() => navigate('/sveska')}>
                    <BookOpen size={48} color="#8b5cf6" />
                    <h3>Sveska</h3>
                    <p>Dnevni pregled termina po satnici i doktoru</p>
                </div>

                <div style={styles.card} onClick={() => navigate('/reminders')}>
                    <MessageSquare size={48} color="#ec4899" />
                    <h3>Podsetnici (SMS)</h3>
                    <p>Sastavljanje SMS poruke za termine po danu</p>
                </div>

                <div style={styles.card} onClick={() => navigate('/sms-log')}>
                    <History size={48} color="#6366f1" />
                    <h3>SMS Istorija</h3>
                    <p>Pregled poslatih poruka i kome su poslate</p>
                </div>

                <div style={styles.card} onClick={() => navigate('/settings')}>
                    <Settings size={48} color="#0d9488" />
                    <h3>Podešavanja</h3>
                    <p>Tretmani, radno vreme i doktori</p>
                </div>

                {isAdmin && (
                    <div style={styles.card} onClick={() => navigate('/users')}>
                        <Users size={48} color="#7c3aed" />
                        <h3>Nalozi</h3>
                        <p>Kreiranje naloga za medicinske sestre i administratore</p>
                    </div>
                )}

                <div style={styles.card} onClick={() => navigate('/account')}>
                    <UserCircle size={48} color="#64748b" />
                    <h3>Moj nalog</h3>
                    <p>Izmena korisničkog imena i lozinke</p>
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: { padding: '40px', minHeight: '100vh', backgroundColor: '#f8fafc' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '50px' },
    userInfo: { display: 'flex', alignItems: 'center', gap: '15px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '25px' },
    card: {
        background: '#fff', padding: '30px', borderRadius: '15px', textAlign: 'center',
        cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s',
        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)', border: '1px solid #e2e8f0'
    },
    logoutBtn: { border: 'none', background: '#fee2e2', color: '#ef4444', padding: '8px', borderRadius: '50%', cursor: 'pointer' }
};

export default Dashboard;